module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-toolbar', {
    attrs: {
      "color": 'primary white--text',
      "dense": _vm.projeto.titulo.length > 130,
      "prominent": _vm.projeto.titulo.length > 130
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.projeto.titulo.length > 130) ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": "primary"
    }
  }, [_c('v-card-title', {
    attrs: {
      "color": "primary white--text"
    }
  }, [_c('div', {
    staticClass: "titulo"
  }, [_vm._v("\n                " + _vm._s(_vm.projeto.classificacaoSecundaria.descricao) + " nº " + _vm._s(_vm.idProjeto) + " - " + _vm._s(_vm.projeto.titulo) + "\n                "), (_vm.extensao.registroSIEX) ? _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    attrs: {
      "href": 'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id,
      "target": "_blank"
    }
  }, [_vm._v("SIEX #" + _vm._s(_vm.extensao.registroSIEX))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.administrador && _vm.extensao.idProjetoDuplicacao ? '(duplicada)' : '') + "\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.titulo.length <= 130) ? _c('v-toolbar-title', [_vm._v("\n            " + _vm._s(_vm.projeto.classificacaoSecundaria.descricao) + " nº " + _vm._s(_vm.idProjeto) + " - " + _vm._s(_vm.projeto.titulo) + "\n            "), (_vm.extensao.registroSIEX) ? _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    attrs: {
      "href": 'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id,
      "target": "_blank"
    }
  }, [_vm._v("SIEX #" + _vm._s(_vm.extensao.registroSIEX))]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.administrador && _vm.extensao.idProjetoDuplicacao ? '(duplicada)' : '') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "show-arrows": "",
      "dark": "",
      "next-icon": "mdi-arrow-right-bold-box-outline",
      "prev-icon": "mdi-arrow-left-bold-box-outline",
      "color": "primary",
      "hide-slider": ""
    },
    slot: "extension"
  }, [_c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoFormulario'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Informações")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ClassificacoesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Classificações")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ExtensaoProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Extensão")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": {
        name: 'IntegrantesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Equipe")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'AtividadesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Atividades")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'VinculosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Vínculos")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ParceriasProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Parcerias")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'AbrangenciaProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ArquivosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Arquivos")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ContatosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.habilitaRelatorio() || (_vm.username === 'athelson.bittencourt' && _vm.idProjeto == 102)) ? _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'RelatoriosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Relatórios")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('router-view', {
    attrs: {
      "idProjeto": _vm.idProjeto,
      "projeto": this.projeto,
      "extensao": this.extensao
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.administrador) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('c-barra-administrador', {
    attrs: {
      "projeto": this.projeto
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae8fa64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto.vue
// module id = 421
// module chunks = 0